<template>
  <div class="icon-container">
    <img :src="$t('summaryView.section_USP.iconUrl')" width="48" />
    <h2 class="icon-description">
      <slot />
    </h2>
  </div>
</template>

<script>
export default {
  name: "IconInfo"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.icon-container {
  margin: 30px 0px;
}

.icon-description {
  font-family: var(--font-default);
  font-size: 18px;
  font-weight: 400;

  @media (min-width: $medium) {
    font-size: 22px;
    padding: 0 75px;
  }
}
</style>
